export default `#ifdef GL_ES
  precision highp float;
#endif

varying float vHeight;
uniform vec3 u_palette[5];
uniform float opacity_threshold_table[4];

void main() {
  
  vec3 color = u_palette[0];
  color = mix(color, u_palette[1], step(abs(opacity_threshold_table[0]), abs(vHeight)));
  color = mix(color, u_palette[2], step(abs(opacity_threshold_table[1]), abs(vHeight)));
  color = mix(color, u_palette[3], step(abs(opacity_threshold_table[2]), abs(vHeight)));
  color = mix(color, u_palette[4], step(abs(opacity_threshold_table[3]), abs(vHeight)));

  gl_FragColor = vec4(color, 1.0);
}`